export default "__VITE_ASSET__Bkk8fyae__"